'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iconLocal = require('./icon.local.css');

var _iconLocal2 = _interopRequireDefault(_iconLocal);

var _iconConfig = require('./icon-config');

var _iconConfig2 = _interopRequireDefault(_iconConfig);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A component for rendering UI icons
 */


var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      rotate = _ref.rotate,
      onClick = _ref.onClick,
      customStyling = _ref.customStyling,
      onFocus = _ref.onFocus,
      onMouseDown = _ref.onMouseDown;
  return _react2.default.createElement('span', {
    className: (0, _classnames2.default)([_iconLocal2.default.base, _iconLocal2.default[color], _iconLocal2.default[size], className]),
    dangerouslySetInnerHTML: {
      __html: _iconConfig2.default[icon]
    },
    style: _extends({
      transform: rotate ? 'rotateZ(' + rotate + 'deg)' : ''
    }, customStyling),
    onClick: onClick,
    onFocus: onFocus,
    onMouseDown: onMouseDown,
    role: 'presentation'
  });
};

Icon.displayName = 'UIIcon';
Icon.defaultProps = {
  color: 'currentColor',
  className: null,
  rotate: null,
  size: 'normal',
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onMouseDown: function onMouseDown() {},
  customStyling: {}
};
Icon.propTypes = {
  /**
   * Pass in custom styling like style={{padding: 10px}}
   */
  customStyling: _propTypes2.default.object,

  /**
   * Listen for icon click event and pass back event
   */
  onClick: _propTypes2.default.func,

  /**
   * Listen for icon focus event and pass back event
   */
  onFocus: _propTypes2.default.func,

  /**
   * Listen for icon onMouseDown event and pass back event
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * Additional className
   */
  className: _propTypes2.default.string,

  /**
   * One of ['currentColor', 'dark', 'light', 'primary', 'primary-hc', 'secondary', 'tertiary']
   */
  color: _propTypes2.default.oneOf(['currentColor', 'dark', 'light', 'primary', 'primary-hc', 'secondary', 'tertiary']),

  /**
   * Name of icon to render.
   */
  icon: _propTypes2.default.oneOf(Object.keys(_iconConfig2.default)).isRequired,

  /**
   * Rotate the icon by degrees [90, 180, 270]
   */
  rotate: _propTypes2.default.oneOf([0, 90, 180, 270]),

  /**
   * one of [xsmall: .5em, small: .75em, normal: 1em, medium: 1.5em, large: 2em]
   */
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'normal', 'medium', 'large'])
};
exports.default = Icon;